import { FC, lazy } from 'react';

import { Route } from 'react-router-dom';

import AppLayout from '@/components/layout/AppLayout';

import EAppRoute from '@/types/appRoutes';

const MainFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.MainFlow })),
);
const BusinessAcquisitionFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.BusinessAcquisitionFlow })),
);
const BankStatementsFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.BankStatementsFlow })),
);

const DebtsFormPageLazy = lazy(() =>
	import('@/pages').then((module) => ({ default: module.DebtsFormPage })),
);

const UploadAttachmentsFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.UploadAttachmentsFlowForm })),
);

const CompleteApplicationFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.CompleteApplicationFlow })),
);

// const OwnerInfoFlowLazy = lazy(() =>
// 	import('@/modules').then((module) => ({ default: module.OwnerInfoFlow })),
// );

interface IFormFlowRoutesProps {
	withoutPartnerSlug?: boolean;
}

export const FormFlowRoutes: FC<IFormFlowRoutesProps> = ({ withoutPartnerSlug }) => {
	const getRoutePath = (path: string): string => {
		if (withoutPartnerSlug) {
			return path.replace(EAppRoute.Partner, '');
		}

		return path;
	};

	return (
		<Route element={<AppLayout />}>
			<Route
				element={<BusinessAcquisitionFlowLazy />}
				path={getRoutePath(EAppRoute.BusinessAcquisition)}
			/>
			<Route
				element={<BusinessAcquisitionFlowLazy />}
				path={getRoutePath(EAppRoute.BusinessAcquisitionWithId)}
			/>
			<Route element={<MainFlowLazy />} index />
			<Route element={<BankStatementsFlowLazy />} path={getRoutePath(EAppRoute.BankStatements)} />
			<Route element={<DebtsFormPageLazy />} path={getRoutePath(EAppRoute.Debts)} />
			<Route
				element={<UploadAttachmentsFlowLazy />}
				path={getRoutePath(EAppRoute.UploadAttachments)}
			/>
			<Route
				element={<CompleteApplicationFlowLazy />}
				path={getRoutePath(EAppRoute.CompleteApplicationWithId)}
			/>
			<Route
				element={<CompleteApplicationFlowLazy />}
				path={getRoutePath(EAppRoute.CompleteApplication)}
			/>
			{/* <Route element={<OwnerInfoFlowLazy />} path={getRoutePath(EAppRoute.OwnerInfo)} /> */}
		</Route>
	);
};
